import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

export const useInventoryMainImage = (onUpload: (files: File[]) => void) => {
    const { t } = useTranslation();
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const inputId = `equipment-inventory-photo-${React.useId()}`;

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(event.currentTarget.files ?? []);

        if (files.length) {
            onUpload(files);
        }

        event.currentTarget.value = '';
    };
    return { t, isLightboxOpen, setIsLightboxOpen, inputId, handleInputChange };
};
